<template>
  <div class="module-container">
    <div class="module-header">
      <div class="module-title" style="font-weight: bolder;">
        <span>巡检管理</span>
      </div>
      <span class="more-link" @click="goToTaskMan">查看更多</span>
    </div>
    <div class="module-content">
      <div v-for="(item, index) in inspectionData" :key="index" class="inspection-item">
        <div class="item-name">{{ item.name }}</div>
        <div class="item-stats">
          <div class="stat-item">
            <span class="stat-label">{{ item.label1 }}</span>
            <span class="stat-value" :title="item.value1">{{ item.value1 }}</span>
          </div>
          <div class="stat-item">
            <span class="stat-label">{{ item.label2 }}</span>
            <span class="stat-value" :title="item.value2">{{ item.value2 }}</span>
          </div>
          <div class="stat-item">
            <span class="stat-label">{{ item.label3 }}</span>
            <span class="stat-value" :title="item.value3">{{ item.value3 }}</span>
          </div>
          <div class="stat-item">
            <span class="stat-label">{{ item.label4 }}</span>
            <span class="stat-value" :title="item.value4">{{ item.value4 }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { workStatisticsGroupByType } from '@/api/reportMan'
import { addDate, getCurTimeYMD } from '@/utils/index'

export default {
  name: 'InspectionManagement',
  data() {
    return {
      inspectionData: [],
      loading: false,
      refreshInterval: null
    }
  },
  mounted() {
    this.fetchInspectionData()
    // 设置定时刷新，每30分钟刷新一次
    this.refreshInterval = setInterval(this.fetchInspectionData, 1800000)
  },
  beforeDestroy() {
    // 清除定时器，避免内存泄漏
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval)
    }
  },
  methods: {
    async fetchInspectionData() {
      this.loading = true
      // 先清空数据，确保即使数据不变也能触发重新渲染
      this.inspectionData = []
      try {
        const projectId = JSON.parse(window.localStorage.userInfo).projectId;
        const endDate = getCurTimeYMD();
        const startDate = addDate(endDate, -7);
        const { data } = await workStatisticsGroupByType({
          projectId: projectId,
          startDate: startDate,
          endDate: endDate
        })
        console.log(data)
        if (data) {
          const total = data.data.total
          const groups = data.data.groups || []

          // 创建现有组的映射
          const groupMap = new Map()
          groups.forEach(group => {
            groupMap.set(group.workTypeText, group)
          })

          // 定义默认四项
          const defaultTypes = ['环境巡检', '工程巡检', '秩序巡检']

          // 构建数据数组
          const inspectionItems = [
            {
              name: '总体',
              label1: '单数',
              value1: total.totalNum || 0,
              label2: '完成单数',
              value2: total.finishNum || 0,
              label3: '执行中',
              value3: total.progressNum || 0,
              label4: '完成率',
              value4: `${total.finishRate || 0}%`
            }
          ]

          // 添加默认类型，不存在则设置为0
          defaultTypes.forEach(type => {
            if (groupMap.has(type)) {
              const group = groupMap.get(type)
              inspectionItems.push({
                name: type,
                label1: '单数',
                value1: group.totalNum || 0,
                label2: '完成单数',
                value2: group.finishNum || 0,
                label3: '执行中',
                value3: group.progressNum || 0,
                label4: '完成率',
                value4: `${group.finishRate || 0}%`
              })
            } else {
              inspectionItems.push({
                name: type,
                label1: '单数',
                value1: 0,
                label2: '完成单数',
                value2: 0,
                label3: '执行中',
                value3: 0,
                label4: '完成率',
                value4: '0%'
              })
            }
          })

          this.inspectionData = inspectionItems
        }
      } finally {
        this.loading = false
        // 确保始终有默认四项数据
        if (this.inspectionData.length === 0) {
          this.inspectionData = [
            { name: '总体', label1: '单数', value1: 0, label2: '完成单数', value2: 0, label3: '执行中', value3: 0, label4: '完成率', value4: '0%' },
            { name: '环境巡检', label1: '单数', value1: 0, label2: '完成单数', value2: 0, label3: '执行中', value3: 0, label4: '完成率', value4: '0%' },
            { name: '工程巡检', label1: '单数', value1: 0, label2: '完成单数', value2: 0, label3: '执行中', value3: 0, label4: '完成率', value4: '0%' },
            { name: '秩序巡检', label1: '单数', value1: 0, label2: '完成单数', value2: 0, label3: '执行中', value3: 0, label4: '完成率', value4: '0%' }
          ]
        }
      }
    },
    goToTaskMan() {
      // 获取用户权限
      const userRoles = JSON.parse(decodeURI(window.localStorage.userRoles))
      // 计算日期参数（最近7天）
      const endDate = getCurTimeYMD()
      const startDate = addDate(endDate, -7)

      // 检查是否有作业任务管理权限
      if (userRoles && userRoles.includes('renwuguanli_web_old')) {
        // 有权限，跳转到作业任务管理
        this.$router.push({
          path: '/qualityMan/taskManNew',
          query: {
            startDate,
            endDate
          }
        });
      } else {
        // 无权限，提示
        this.$message({
          type: 'warning',
          message: '您暂无权限访问作业任务管理'
        });
      }
    }
  }
}
</script>

<style scoped lang="scss">
.module-container {
  height: 280px;
  display: flex;
  flex-direction: column;
}

.module-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.module-title {
  font-family: Source Han Sans CN;
  font-weight: 800;
  font-size: 19px;
  color: #FFFFFF;
  width: 430px;
  height: 35px;
  color: #fff;
  text-align: center;
  background: url("/static/image/equip/shebeiyunxingzhuangtai-bg.png") no-repeat center;

  span {
    margin-left: -187px;
  }
}

.more-link {
  font-size: 12px;
  color: #fff;
  cursor: pointer;
  transition: all 0.3s;
}

.more-link:hover {
  // 显示下划线
  text-decoration: underline;
}

.module-content {
  margin: 12px 0;
  display: flex;
  flex-direction: column;
  /* gap: 12px; */
  flex: 1;
  overflow-y: auto;
  scrollbar-width: none;
}

.module-content::-webkit-scrollbar {
  width: 0 !important;
}

.inspection-item {
  width: 457px;
  height: 54px;
  display: flex;
  align-items: center;
  cursor: pointer;
  background-image: url('/static/image/six/background-blue.png');
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100% 110%;
  padding: 10px 15px 10px 85px;
  margin-left: 12px;
}

.inspection-item:first-child {
  background-image: url('/static/image/six/background-yellow.png');
}

.item-name {
  font-size: 18px;
  color: #fff;
  font-weight: 600;
  width: 95px;
  margin-right: 20px;
}

.item-stats {
  display: flex;
  gap: 10px;
  flex: 1;
  align-items: center;
}

.stat-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 55px;
}

.stat-label {
  font-size: 14px;
  color: #fff;
  margin-bottom: 4px;
  width: 58px;
}

.stat-value {
  font-size: 21px;
  color: #fff;
  font-weight: 600;
  width: 55px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
